import { createFileRoute, redirect } from "@tanstack/react-router";
import { Outlet } from "@tanstack/react-router";
import { Roles } from "@hometoq/backend/enums";
import {
  SidebarProvider,
  SidebarTrigger,
  SidebarInset,
} from "@/components/ui/sidebar";
import { AppSidebar } from "@/routes/dashboard/client/-components/AppSideBar";
import { Footer } from "@/components/layouts/Footer";
import { getCurrentUserSafe } from "@/domain/auth/auth.query";

export const Route = createFileRoute("/dashboard/client")({
  beforeLoad: async () => {
    const user = await getCurrentUserSafe();
    if (!user) {
      throw redirect({ to: "/connexion" });
    }

    if (user.role !== Roles.CUSTOMER) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SidebarProvider className="relative">
      <AppSidebar />
      <SidebarInset>
        <SidebarTrigger size={"lg"} className="lg:sticky lg:top-0" />
        <Outlet />
        <Footer />
      </SidebarInset>
    </SidebarProvider>
  );
}
